// The ONE definition of "this tool call produced a linkable item" — used by
// BOTH halves of the timeline (AI-301, tickets/ai.md):
//   live turn    — simoneAiTransport.onToolCall stamps the client tool's own
//                  return value onto its timeline row (the server's later
//                  `completed` frame carries only a summary string)
//   history load — sessions._toChatMessages restores it from the persisted
//                  tool_result payload, so links survive a reload
// aiWorkspaceOps write tools return ok({ created: { kind, id, title|name } });
// anything else (reads, updates, failures, denials) normalizes to null.
export const toolOutcome = (res) => {
  if (!res || typeof res !== 'object' || res.ok === false) return null
  const c = res.created
  if (!c || typeof c !== 'object' || c.id == null || c.id === '') return null
  return {
    kind: String(c.kind || 'item'),
    id: String(c.id),
    title: String(c.title || c.name || '')
  }
}

// The ONE definition of "why this tool call failed", in words a person (and
// the keepz lane reading a screenshot) can act on — used by the same two
// halves as toolOutcome: the live stamp (simoneAiTransport.onToolCall) and the
// history fold (sessions._toChatMessages). Measured on dev 2026-10-15 (Keepz
// DEV, "Show me payment pay_09lUkppFn"): two render_answer_ui draws were
// refused before the third drew — a parse error, then `generated_app_blocked`
// for `Badge` + a markup key — and the timeline showed a bare ✗ with no
// reason; the server summary carried only the code. The reason is the
// result's own error (a string or `{ message }`) followed by each violation
// (`rule: detail`), capped. Success, or a failure with nothing to say → null.
const FAILURE_MAX = 240
export const toolFailure = (res) => {
  if (!res || typeof res !== 'object' || res.ok !== false) return null
  const err = res.error
  const head =
    typeof err === 'string'
      ? err.trim()
      : err && typeof err === 'object' && typeof err.message === 'string'
        ? err.message.trim()
        : ''
  const list = Array.isArray(res.violations) ? res.violations : []
  const parts = []
  for (const v of list) {
    let s = ''
    if (typeof v === 'string') s = v.trim()
    else if (v && typeof v === 'object' && v.rule) {
      const d = v.detail == null ? '' : String(v.detail).trim()
      s = d ? `${v.rule}: ${d}` : String(v.rule)
    }
    if (s && !parts.includes(s)) parts.push(s)
  }
  const tail = parts.slice(0, 4).join(' · ')
  const out = head && tail ? `${head} — ${tail}` : head || tail
  if (!out) return null
  return out.length > FAILURE_MAX ? out.slice(0, FAILURE_MAX - 1) + '…' : out
}
